import { render } from "./DisciplineModal.vue?vue&type=template&id=09585382&ts=true"
import script from "./DisciplineModal.vue?vue&type=script&lang=ts"
export * from "./DisciplineModal.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__